import { render } from "./PoolCard.vue?vue&type=template&id=8a3306c0&scoped=true&ts=true"
import script from "./PoolCard.vue?vue&type=script&lang=ts"
export * from "./PoolCard.vue?vue&type=script&lang=ts"

import "./PoolCard.vue?vue&type=style&index=0&id=8a3306c0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3306c0"]])

export default __exports__